import { createElement, memo } from '@max/max';
import { RuleModal as RuleModalComp } from '@nibfe/marketing-blocks-universal';
import { navigateTo } from '@max/meituan-uni-navigate';
const getActivityRuleContent = (config) => {
    const { firstContent, firstTitle, secondContent, secondTitle, thirdContent, thirdTitle } = config;
    const ruleList = [];
    if (firstContent) {
        ruleList.push({
            title: firstTitle || '',
            content: firstContent || ''
        });
    }
    if (secondContent) {
        ruleList.push({
            title: secondTitle || '',
            content: secondContent || ''
        });
    }
    if (thirdContent) {
        ruleList.push({
            title: thirdTitle || '',
            content: thirdContent || ''
        });
    }
    return ruleList;
};
const RuleModal = (props) => {
    const { activityRulePicture, modalTitle, modalTitleColor, onClose, visible } = props;
    const activityRuleContent = getActivityRuleContent(props);
    const onLinkClick = (_title, url) => {
        if (url) {
            navigateTo({
                url,
                _web: {
                    miniProgramNative: true
                }
            });
        }
    };
    return <RuleModalComp headerImage={activityRulePicture} ruleTitle={modalTitle} ruleTitleColor={modalTitleColor} headerType="IMAGE" visible={visible} handleClickTextLink={onLinkClick} ruleDescription={activityRuleContent || []} onHide={onClose}/>;
};
// 不是顶层组件，不顶用，意思意思一下
RuleModal.__isModalModule__ = true;
RuleModal.__isHoverModule__ = true;
export default memo(RuleModal);
